import { ProductGraphicPreferenceStatus } from '../../../models';
import { GameData } from '../../data';
import { GraphicsConfig } from '../../game-config';

export function addCustomGraphicFieldMigrator(game: GameData): GameData {
  if (!game.config.graphicsConfig?.status) {
    if (!game.config.graphicsConfig) {
      game.config.graphicsConfig = new GraphicsConfig(null);
    }
    game.config.graphicsConfig.status = ProductGraphicPreferenceStatus.CUSTOM;
  }
  return game;
}
